export const UNIT_TYPES = {
  KD: "KD",
  D: "D",
  P: "P",
  HM: "HM",
  HM2: "HM2",
};

export const UTypeValues: string[] = Object.values(UNIT_TYPES);
export type UnitType = (typeof UTypeValues)[number];
